import { LineChart } from '@mantine/charts';
import { Card, Group, Skeleton, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { FormAnalyticsByDay } from '@/api';

export interface VolumeChartProps {
  data: FormAnalyticsByDay[];
  /** When true, render a skeleton instead of the empty-state copy. */
  loading?: boolean;
}

export function VolumeChart({ data, loading = false }: VolumeChartProps) {
  const { t } = useTranslation();

  return (
    <Card withBorder padding="md" radius="md" h="100%">
      <Group justify="space-between" mb="sm">
        <Text fw={600}>{t('messages.volumeTrends')}</Text>
      </Group>
      {loading ? (
        <Skeleton h={240} radius="sm" />
      ) : data.length === 0 ? (
        <Text c="dimmed" ta="center" py="xl">
          {t('messages.emptyChart')}
        </Text>
      ) : (
        <LineChart
          h={240}
          data={data}
          dataKey="date"
          series={[
            { name: 'view_count', color: 'gray.5', label: t('messages.views') },
            { name: 'message_count', color: 'primary.6', label: t('messages.messages') },
          ]}
          withLegend
          tickLine="x"
          gridAxis="y"
          curveType="natural"
        />
      )}
    </Card>
  );
}
